import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, vShow as _vShow, mergeProps as _mergeProps, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "relative w-full flex flex-col" }
const _hoisted_3 = ["placeholder"]
const _hoisted_4 = { class: "bg-white z-40 absolute left-0 top-full w-full overflow-y-scroll max-h-[50vh] rounded text-sm" }
const _hoisted_5 = ["onMousedown"]
const _hoisted_6 = {
  key: 0,
  class: "text-red-800 text-sm ml-3"
}

import { ref, PropType, inject, computed, Ref, watch } from "vue";
import axios, { AxiosRequestConfig, CancelTokenSource } from "axios";
import { nextTick } from "vue";
import {
  FormValidatedValuesKey,
  FormValidatedUpdateKey,
  FormValidatedErrorsKey,
} from "../../types/inject";

type SearchInRecord = {
  campo: string;
  reRemove?: RegExp;
  suffix?: string;
  prefix?: string;
  operador?: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'Bobjeto',
  props: {
  objeto: {
    type: String,
    required: true,
  },
  searchIn: {
    type: [String, Array] as PropType<string | SearchInRecord[]>,
    required: true,
  },
  name: {
    type: String,
    required: true,
  },
  name_term: {
    type: String,
    required: false,
  },
  campos: {
    type: String,
    required: false,
  },
  objName: String,
  label: String,
  includes: {
    type: String,
    default: "",
  },
  modoObjeto: {
    required: false,
    default: false,
  },
  condicaoFixa: {
    type: Array as PropType<
      { campo: string; operador: string; valor: string }[]
    >,
    required: false,
    default: () => [],
  },
  tclass: {
    type: String,
  },
  disabled: {
    type: Boolean,
    required: false,
  },
  order: {
    type: String,
    default: "",
  },
  noFilterCia: {
    type: Boolean,
    default: false,
  },
},
  emits: ["afterUpdate", "onLoadObject"],
  setup(__props, { emit }) {

const props = __props;





// Original
const valuesOriginal = inject(FormValidatedValuesKey, {});
const onUpdateOriginal = inject(FormValidatedUpdateKey);
const errors = inject(FormValidatedErrorsKey, {});
const error = computed(() => errors[props.name]);

const selectedValue = computed(() => {
  return valuesOriginal[props.name] as string | undefined;
});

const objSelected: Ref<any | null> = ref(null);

const debounce = createDebounce();

const items = ref([] as any[]);
const inputSearch = ref();
const term = ref("");
const listShow = ref(false);
const loader = ref(false);
const highlightedIndex = ref(-1);

const keyPress = (e: KeyboardEvent) => {
  console.debug("Key pressed", e.key);
  if (e.key === "ArrowDown") {
    highlightedIndex.value =
      highlightedIndex.value + 1 >= items.value.length
        ? 0
        : highlightedIndex.value + 1;
    e.preventDefault();
    return;
  }
  if (e.key === "ArrowUp") {
    highlightedIndex.value =
      highlightedIndex.value <= 0
        ? (highlightedIndex.value = items.value.length - 1)
        : highlightedIndex.value - 1;
    e.preventDefault();
    return;
  }
  if (e.key === "Enter") {
    e.preventDefault();
    if (items.value[highlightedIndex.value]) {
      console.debug("Selecting", items.value[highlightedIndex.value]);
      select(items.value[highlightedIndex.value]);
    }
    return;
  }
  debounce(async () => {
    await loadData(e);
  }, 250);
};

const activeTokensLoad: CancelTokenSource[] = [];

const loadObject = async (ukey: string) => {
  console.log("Requesting load", props.objeto, ukey, activeTokensLoad.length);
  if (activeTokensLoad.length > 0) {
    for (let i = 0; i < activeTokensLoad.length; i++) {
      activeTokensLoad[i].cancel("canceled");
    }
    activeTokensLoad.splice(0, activeTokensLoad.length);
  }

  loader.value = true;

  let suffix = "";
  if (props.includes) {
    suffix = `?include=${props.includes}`;
  }

  if (props.noFilterCia) {
    if (suffix) {
      suffix += "&noFilterCia=1";
    } else {
      suffix += "?noFilterCia=1";
    }
  }

  try {
    const cancelTokenSource = axios.CancelToken.source();
    const idxToken = activeTokensLoad.push(cancelTokenSource);

    const response = await axios.get(
      encodeURI(`/${props.objeto}/${ukey}${suffix}`),
      {
        customLoader: true,
        cancelToken: cancelTokenSource.token,
      } as AxiosRequestConfig & { customLoader: boolean }
    );
    activeTokensLoad.splice(idxToken, 1);
    objSelected.value = response.data;
    emit("onLoadObject", response.data);
  } catch (err) {
    console.error("Error on load axios", err);
  }
  loader.value = false;
  listShow.value = false;
};
if (selectedValue.value) {
  console.log("InputBObjeto", props.objeto, selectedValue.value);
  loadObject(selectedValue.value || "");
}

const activeTokens: CancelTokenSource[] = [];

const loadData = async (event: KeyboardEvent) => {
  if (
    (event.keyCode > 8 && event.keyCode < 48) ||
    (event.keyCode > 90 && event.keyCode < 96) ||
    (event.keyCode > 111 && event.keyCode < 186)
  ) {
    return;
  }
  highlightedIndex.value = -1;
  if (term.value.length == 0) {
    items.value = [];
    return;
  }
  if (props.name_term) {
    typeof onUpdateOriginal === "function" &&
      onUpdateOriginal({ [props.name_term]: term.value });
  }
  if (activeTokens.length > 0) {
    for (let i = 0; i < activeTokens.length; i++) {
      activeTokens[i].cancel("canceled");
    }
    activeTokens.splice(0, activeTokens.length);
  }
  const search = ["["];
  if (typeof props.searchIn === "string") {
    const searchIn = props.searchIn.split(",");
    searchIn.forEach((item) => {
      search.push(`${item}|like|%${term.value}%;`);
    });
  } else {
    props.searchIn.forEach((se) => {
      let valueToSearch = term.value;
      if (se.reRemove instanceof RegExp) {
        valueToSearch = valueToSearch.replace(se.reRemove, "");
      }
      if (valueToSearch.length > 0) {
        search.push(
          `${se.campo}|${se.operador || "like"}|${
            se.prefix || ""
          }${valueToSearch}${se.suffix || ""};`
        );
      }
    });
  }
  search.push("];");
  props.condicaoFixa.forEach((item) => {
    search.push(`${item.campo}|${item.operador}|${item.valor};`);
  });

  let suffix = "";
  if (props.includes) {
    suffix = `&include=${props.includes}`;
  }

  if (props.noFilterCia) {
    suffix += "&noFilterCia=1";
  }
  if (props.campos) {
    suffix += `&s=${props.campos}`;
  }
  console.debug("status listshow", listShow.value, selectedValue.value);

  try {
    const cancelTokenSource = axios.CancelToken.source();
    const idxToken = activeTokens.push(cancelTokenSource);

    loader.value = true;

    const response = await axios.get(
      encodeURI(
        `/${props.objeto}?q=${search.join("")}${suffix}&o=${props.order}`
      ),
      {
        customLoader: true,
        cancelToken: cancelTokenSource?.token,
      } as AxiosRequestConfig & { customLoader: boolean }
    );
    activeTokens.splice(idxToken, 1);
    if (!response) return;
    items.value = response.data.data;
    loader.value = false;
  } catch (err) {
    loader.value = false;
    console.error("Error on request", err);
  }
};

const clear = () => {
  objSelected.value = null;
  term.value = "";
  nextTick(() => inputSearch.value.focus());
  const objUpdate = { [props.name]: null };
  if (props.objName) {
    objUpdate[props.objName] = null;
  }

  typeof onUpdateOriginal === "function" && onUpdateOriginal(objUpdate);
  emit("afterUpdate", null);
  if (props.name_term) {
    typeof onUpdateOriginal === "function" &&
      onUpdateOriginal({ [props.name_term]: '' });
  }
};

const select = (obj: any) => {
  objSelected.value = obj;
  listShow.value = false;
  const objUpdate = { [props.name]: obj.ukey };
  if (props.objName) {
    objUpdate[props.objName] = obj;
  }
  typeof onUpdateOriginal === "function" && onUpdateOriginal(objUpdate);
  emit("afterUpdate", obj);
  if (props.name_term) {
    typeof onUpdateOriginal === "function" &&
      onUpdateOriginal({ [props.name_term]: '' });
  }
};

watch(
  () => selectedValue.value,
  (newVal) => {
    console.log("InputBObjeto", props.objeto, selectedValue.value);

    if (newVal && !objSelected.value) {
      loadObject(selectedValue.value || "");
    } else if (
      newVal &&
      objSelected.value &&
      newVal != objSelected.value.ukey
    ) {
      loadObject(selectedValue.value || "");
    }
  },
  {
    deep: true,
  }
);

function createDebounce() {
  let timeout: number | undefined = undefined;
  return function (fnc: () => void, delayMs: number) {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      fnc();
    }, delayMs || 500);
  };
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["group relative", __props.tclass]),
    onFocusCapture: _cache[2] || (_cache[2] = ($event: any) => (listShow.value = true)),
    onBlurCapture: _cache[3] || (_cache[3] = ($event: any) => (listShow.value = false))
  }, [
    _withDirectives(_createElementVNode("div", _mergeProps({
      class: ["flex flex-col relative w-full", {
        'p-0': !__props.label,
        'py-2 px-3': !!__props.label,
      }]
    }, _ctx.$attrs), [
      (!!__props.label)
        ? (_openBlock(), _createElementBlock("label", _hoisted_1, _toDisplayString(__props.label), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _withDirectives(_createElementVNode("input", {
          class: _normalizeClass(["p-2 border rounded", { 'border-red-800': _unref(error) && _unref(error).length > 0 }]),
          type: "text",
          onKeydown: keyPress,
          placeholder: __props.label,
          ref_key: "inputSearch",
          ref: inputSearch,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((term).value = $event))
        }, null, 42, _hoisted_3), [
          [_vModelText, term.value]
        ])
      ])
    ], 16), [
      [_vShow, !_unref(selectedValue)]
    ]),
    _withDirectives(_createElementVNode("label", { class: "ml-3" }, _toDisplayString(__props.label), 513), [
      [_vShow, !!_unref(selectedValue) && !!__props.label]
    ]),
    _withDirectives(_createElementVNode("div", {
      class: _normalizeClass(["z-10 absolute opacity-70 right-6", {
        'top-10': !!__props.label,
        'top-2': !__props.label,
      }])
    }, [
      _createVNode(_component_font_awesome_icon, {
        icon: "sync-alt",
        spin: ""
      })
    ], 2), [
      [_vShow, loader.value]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item, i) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.ukey
        }, [
          _createElementVNode("div", {
            onMousedown: ($event: any) => (select(item)),
            class: _normalizeClass(["mx-4 rounded p-2 mb-1 bg-gray-100 hover:bg-gray-200 cursor-pointer", { 'bg-gray-200': highlightedIndex.value === i }])
          }, [
            item
              ? _renderSlot(_ctx.$slots, "exibicao", {
                  key: 0,
                  isListItem: true,
                  item: item
                })
              : _createCommentVNode("", true)
          ], 42, _hoisted_5)
        ]))
      }), 128))
    ], 512), [
      [_vShow, listShow.value && !_unref(selectedValue)]
    ]),
    _withDirectives(_createElementVNode("div", {
      onDblclick: _cache[1] || (_cache[1] = ($event: any) => (clear())),
      class: _normalizeClass(["bg-gray-50 border h-min-16 flex items-center justify-between p-2 relative rounded", {
        'mx-3': !!__props.label,
      }])
    }, [
      (objSelected.value)
        ? _renderSlot(_ctx.$slots, "exibicao", {
            key: 0,
            isListItem: false,
            item: objSelected.value
          })
        : _createCommentVNode("", true),
      (!__props.disabled)
        ? (_openBlock(), _createElementBlock("span", {
            key: 1,
            onClick: clear,
            class: "block cursor-pointer h-8 hover:bg-gray-200 pb-1 px-3 text-2xl"
          }, [
            _withDirectives(_createElementVNode("span", null, "x", 512), [
              [_vShow, !loader.value]
            ])
          ]))
        : _createCommentVNode("", true)
    ], 34), [
      [_vShow, _unref(selectedValue)]
    ]),
    (_unref(error) && _unref(error).length > 0)
      ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_unref(error)), 1))
      : _createCommentVNode("", true)
  ], 34))
}
}

})